import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-012621a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-2 font-semibold text-white cursor-default" }
const _hoisted_2 = ["href"]

import isMobile from "is-mobile";
import { ref, computed, onMounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { MenuEntry } from "@/types/Sidebar";
import useMousePosition from "@/types/useMousePosition";
import SafeArea from "./SidebarSafeArea.vue";

type SubmenuStyle = {
  position: "absolute" | "relative" | "fixed" | "sticky";
  left: string;
  top?: string;
  bottom?: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarSafeAreaNestedOption',
  props: {
    menuRect: {},
    item: {}
  },
  setup(__props: any) {

const open = ref(false);
const parent = ref<HTMLElement | null>(null);
const child = ref<HTMLElement | null>();
const disablePointerEvents = ref(false);
const isSafeAreaOpen = ref(true);
const parentRect = ref();
const router = useRouter();
const submenuRect = ref();
const props = __props;

onMounted(() => {
  submenuRect.value = child.value?.getBoundingClientRect();
  parentRect.value = parent?.value?.getBoundingClientRect();
});

const mouseAt = useMousePosition();
let timeout = undefined as ReturnType<typeof setTimeout> | undefined;

const parentWidth = computed(() => (parent.value ? parent.value.offsetWidth : 0));

watch(
  mouseAt,
  () => {
    if (!parentRect.value || !props.menuRect) {
      return;
    }

    const isWithinItem =
      mouseAt.value.x > parentRect.value.x &&
      mouseAt.value.y > parentRect.value.y &&
      mouseAt.value.x < parentRect.value.x + parentRect.value.width &&
      mouseAt.value.y < parentRect.value.y + parentRect.value.height;

    const isWithinMenu =
      mouseAt.value.x > props.menuRect.x && // Check if x exists
      mouseAt.value.y > props.menuRect.y && // Check if y exists
      mouseAt.value.x < props.menuRect.x + props.menuRect.width &&
      mouseAt.value.y < props.menuRect.y + props.menuRect.height;

    if (!isWithinItem && isWithinMenu) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        open.value = false;
      }, 300); // Delay for smooth transition
    } else {
      clearTimeout(timeout);
    }
  },
  { deep: true },
);

const handleClick = () => {
  if (!isMobile({ tablet: true, featureDetect: true })) {
    if (props?.item?.route && !props.item.isClickable) {
      router.push(props.item.route);
    } else if (
      props?.item?.options &&
      props?.item?.options[0].items &&
      props?.item?.options[0]?.items[0]?.route &&
      !props.item.isClickable
    ) {
      router.push(props?.item?.options[0]?.items[0]?.route);
    }
  }
};
watch(child, () => {
  submenuRect.value = child.value?.getBoundingClientRect();
});

const route = useRoute();

watch(
  () => route.query.id,
  () => {
    open.value = false;
  },
);

const submenuPositionStyle = computed(() => {
  const style: SubmenuStyle = { position: "absolute", left: `${parentWidth.value}px` };
  const viewportHeight = window.innerHeight;
  if (submenuRect.value && parentRect.value) {
    if (submenuRect.value.bottom > viewportHeight) {
      style.bottom = "0";
    } else {
      style.top = "0";
    }
  }
  return style;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'w-full',
      (props?.item?.route || (props?.item?.options && props?.item?.options[0]?.items[0]?.route)) &&
        'cursor-pointer',
    ]),
    ref_key: "parent",
    ref: parent,
    style: {"position":"relative"},
    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (open.value = true)),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (open.value = false)),
    onClick: handleClick
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        _ctx.item?.current
          ? 'bg-oaiGray-400 text-yellow-400 currentMenuItem'
          : 'text-white-900 hover:text-yellow-400',
        open.value && 'bg-oaiGray-400 text-yellow-400',
      ])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    (open.value && isSafeAreaOpen.value && parent.value && child.value)
      ? (_openBlock(), _createBlock(SafeArea, {
          key: 0,
          anchor: parent.value,
          submenu: child.value,
          disablePointerEvents: disablePointerEvents.value
        }, null, 8, ["anchor", "submenu", "disablePointerEvents"]))
      : _createCommentVNode("", true),
    (open.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "customSubMenu min-w-64 submenu-container opacity-100",
          style: _normalizeStyle(submenuPositionStyle.value),
          ref_key: "child",
          ref: child,
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [
          _renderSlot(_ctx.$slots, "customContent", {}, () => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item?.options, (optionList, idx) => {
              return (_openBlock(), _createElementBlock("div", { key: idx }, [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.item?.name || optionList.title), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionList?.items, (option) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: option.name,
                    class: _normalizeClass([
              option?.current ? ' text-yellow-400' : 'hover:text-yellow-400',
              'flex gap-x-3 group hover:border-white border-l border-gray-400 cursor-pointer text-sm leading-6 ',
            ])
                  }, [
                    (option.route)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: option?.route,
                          class: "w-full flex items-center gap-1 mx-2 px-2 py-1 rounded-md hover:bg-oaiGray-300"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(option?.icon), {
                              class: "h-4 w-4 shrink-0",
                              "aria-hidden": "true"
                            })),
                            _createTextVNode(" " + _toDisplayString(option?.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true),
                    (option.url)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: option.url,
                          class: "w-full flex items-center gap-1 mx-2 px-2 py-1 rounded-md hover:bg-oaiGray-300",
                          target: "_blank"
                        }, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(option?.icon), {
                            class: "h-4 w-4 shrink-0",
                            "aria-hidden": "true"
                          })),
                          _createTextVNode(" " + _toDisplayString(option?.name), 1)
                        ], 8, _hoisted_2))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ]))
            }), 128))
          ])
        ], 4))
      : _createCommentVNode("", true)
  ], 34))
}
}

})